import type { FaireProductEntity } from "../../entity_types/product";

export const p_bbd36mhn67: FaireProductEntity = {
  token: "p_bbd36mhn67",
  type: "product",
  name: "Color Garden Beaded Necklace – Natural Stone Beads Mix",
  brandToken: "b_eow5j1bbc8",
  brandName: "Ellison+Young",
  imageUrl:
    "https://cdn.faire.com/fastly/bdd8a375a927edd0a944f482d4cd6b3f8052480600fb082eefec33f8e28fd305.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f22935cc0f809250ac54b15734b81ee64172a23bd796cd1e0c72aef37e3eafb6.png",
    "https://cdn.faire.com/fastly/606a6db18abd5d01d3161f32f32d64427a56b8fc1c2ae08a09d9791108213098.png",
    "https://cdn.faire.com/fastly/764506850ce2b86c9ff7c13f4cd76f2470d2a20e3f515c10a9ee486fb1ccb53e.png",
    "https://cdn.faire.com/fastly/ffd33d4b73315ee8288d2739f9c3820d9c8172a533da52474fe634f37ff2f45f.png",
    "https://cdn.faire.com/fastly/7d16db49dbf6d1d25983ed9c61037340f55542b388327476431980b8c8c8bff5.png",
    "https://cdn.faire.com/fastly/c03077c5c4692ca16394b565280fbb5cf0d0ba5bd32fce68f783c8a5ae4ceb91.png",
    "https://cdn.faire.com/fastly/0816dfaa3a279ffaa24b3592cd8f9eb3536b7563ffb0231e84668f1a293fc704.png",
    "https://cdn.faire.com/fastly/129b4ae0b3668ba519e3e5404cded6b4b0c9da25017598c114ee8089bcf1dad8.jpeg",
    "https://cdn.faire.com/fastly/dc842124f1382aed2238b6e49dbe30f985b20e26329d85b45f75b97e68f01896.png",
    "https://cdn.faire.com/fastly/d446bde1c34b8b41786ae3776cf30eaaacbb267ee074eaa82536f65b4c7dbeeb.png",
  ],
  priceDollars: 12.5,
  description:
    'Bring a soft, colorful charm to your everyday look with the Color Garden Mixed Beaded Necklace. Designed with a beautiful wave of acrylic and natural stone beads, this piece blends playful color with a natural, effortless feel—perfect for layering or wearing on its own.\n\n• Mixed Bead Design – A curated blend of acrylic and natural stone beads in a soft color wave\n• Effortless Styling – Adds a fresh pop of color to both casual and elevated looks\n• Layering Friendly – Perfect to wear solo or styled with other necklaces\n• Gold-Tone Accents – Finished with 18K gold plated brass hardware for a polished touch\n• Lightweight & Comfortable – Easy to wear all day\n\nDimensions: 16" length with 2" extender\nMaterials: Acrylic beads, natural stone beads, 18K gold plated brass\nFeatures: Lightweight, adjustable length\nImported',
  tags: [],
  msrpDollars: 31.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:59.829Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
